// import PredictiveSearch from './modules/predictive-search';
import CollectionScroller from './modules/collection-scroller';
import DropdownSelector from './modules/dropdown-selector';

// new PredictiveSearch();
new CollectionScroller();
new DropdownSelector();
